import { useMemo } from 'react';
import { useQuery } from 'react-query';

import qriServiceApi from '../api/qriServiceApi.api';
import { QualityEventDetailsResponse } from '../types';
import { extractRelatedQrisFromQueryEventData } from '../utils/qriUtils';

export const EventQrisQueryKey = 'eventQris';

export const useEventQris = (eventData: QualityEventDetailsResponse | undefined) => {
  const sortedQris = useMemo(() => [...extractRelatedQrisFromQueryEventData(eventData)].sort(), [eventData]);

  const qriQuery = useQuery([EventQrisQueryKey, sortedQris], () => qriServiceApi.getBulkDetails(sortedQris), {
    enabled: sortedQris.length > 0,
  });

  const derived = useMemo(() => {
    const values = Object.values(qriQuery.data ?? {});
    return {
      suppliersData: values.filter((d) => d.domain === 'suppliers'),
      relatedDocumentsData: values.filter((d) => d.domain === 'documents'),
      relatedEventsData: values.filter((d) => d.domain === 'quality-events'),
    };
  }, [qriQuery.data]);

  return {
    ...derived,
    isError: qriQuery.isError,
    isFetching: qriQuery.isFetching,
  };
};
